import React from 'react';
import { NoDataTab } from 'javascripts/analytics/components/NoDataTab';
import { ReferersTable } from './referers_table';

export class LinksTabContainer extends React.Component {
  getStateFromStore = () => {
    return {
      refererPairs: Aedu.ReduxStore.getState().AnalyticsDashboard.RefererPairs,
      displayedDates:
        Aedu.ReduxStore.getState().AnalyticsDashboard.DisplayedDates,
    };
  };

  state = this.getStateFromStore();

  componentDidMount() {
    this.unsubscribe = Aedu.ReduxStore.subscribe(
      function () {
        this.setState(this.getStateFromStore());
      }.bind(this),
    );

    Aedu.ReduxStore.dispatch(
      Aedu.ActionCreators.AnalyticsDashboard.RefererPairs.fetch(),
    );
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {
    if (this.state.refererPairs.models.length !== 0) {
      return (
        <ReferersTable
          refererPagePairs={this.state.refererPairs.models}
          dayCount={this.state.displayedDates.dayCount}
        />
      );
    } else if (this.state.refererPairs.meta.fetching) {
      return (
        <div className="u-taCenter u-pv4x">
          <i className="fa fa-spin fa-spinner u-fs36"></i>
        </div>
      );
    } else {
      return (
        <NoDataTab
          title="No one has linked to your papers yet."
          details="To get more links to your work, make sure you've<br>uploaded and thoroughly tagged all your papers. As people link to your work, this page will populate with data."
        />
      );
    }
  }
}
